import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_492: DocMigration = {
  maxSchemaVersion: "0.0.492",
  description: "Remove default value for homePlanShowroomURL in homeAttributes",
  apply(json: any): any {
    delete json.attributes.homePlanShowroomURL;
    return json;
  },
};

export default migration_0_0_492;
